import styled from "styled-components";

export const SwitchContainer = styled.label<{ minWidth?: string, $disabled?: boolean }>`
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 0.4rem;
    border: 1px solid ${({ theme }) => theme.colors.lightItemBorder};
    padding: 0.8rem 0.5rem;
    width: fit-content;

    ${({ $disabled }) => $disabled && `
        cursor: not-allowed;
        opacity: 0.6;
    `}
`;

export const Toggle = styled.div<{ checked: boolean, $disabled?: boolean }>`
    position: relative;
    width: 30px;
    height: 14px;
    border-radius: 20px;
    background-color: ${({ checked }) => (checked ? "#4caf50" : "#ccc")};
    transition: background-color 0.2s;
    margin-right: 10px;
    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};

    &:before {
        content: "";
        position: absolute;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #fff;
        top: 2px;
        left: ${({ checked }) => (checked ? "17px" : "2px")};
        transition: left 0.2s;
    }
`;

export const Label = styled.span`
    font-size: 1.1rem;
    font-weight: 400;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
